import * as React from 'react';
export const downloadSvg = React.forwardRef(function downloadSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.75 1a.75.75 0 0 0-1.5 0v8.69L5.03 7.47a.75.75 0 0 0-1.06 1.06l3.5 3.5a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 0 0-1.06-1.06L8.75 9.69V1Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M1.25 11a.75.75 0 0 1 .75.75V14h12v-2.25a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-.75.75H1.25a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 .75-.75Z',
    }),
  );
});
downloadSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var download = {
  category: 'icon',
  colorable: true,
  name: 'download',
  svg: downloadSvg,
};
